import { createMuiTheme as createMUITheme } from '@material-ui/core/styles';
import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import {
	Palette,
	CustomTheme,
	createDefaultTheme,
	lighten,
} from '@seeneco-ui/core/styles';


interface ICustomThemeOptions extends ThemeOptions {
	customTheme: {},
};
interface IStyledTheme extends CustomTheme {}
type WithThemeProps = { theme: IStyledTheme };

const baseFontSize = 14;

const getThemeObjectByName = (name: string): CustomTheme => {
	const map = {
		default: createDefaultTheme()
	};

	return map[name] || map['default'];
};

const pxToRem = (size: number) => `${(size / baseFontSize) * 1}rem`;

const getMeasureProp = (v: string | number) => typeof v === 'string' ? v : v + 'px';

const createReactMaterialTheme = (themeName: string) => {
	const map = {
		default: () => {
			const theme = getThemeObjectByName(themeName);

			return createMUITheme({
				palette: {
					primary: {
						dark: theme.color.accentPrimary,
						main: theme.color.accentPrimary,
					},
					text: {
						primary: theme.color.blackPrimary,
						secondary: theme.color.blackSecondary,
					},
					action: {
						disabledBackground: theme.color.whiteStealthy,
						disabled: theme.color.blackDisabled,
					},
					error: {
						contrastText: theme.color.whitePrimary,
						main: theme.color.dangerPrimary
					}
				},
				overrides: {
					MuiDialog: {
						paperWidthSm: {
							maxWidth: 730
						},
						paper: {
							overflowX: 'hidden'
						}
					},
					MuiBackdrop: {
						root: {
							backgroundColor: 'rgba(62, 71, 87, 0.7)',
						}
					}
				},
				customTheme: theme,
			} as ICustomThemeOptions);
		},
	};

	return map[themeName] ? map[themeName]() : map['default']();
};

const createStyledTheme = (themeName: string): IStyledTheme => getThemeObjectByName(themeName);


export {
	IStyledTheme,
	WithThemeProps,
	createReactMaterialTheme,
	createStyledTheme,
	pxToRem,
	getMeasureProp,
};
